module.exports = __webpack_public_path__ + "img/smart-climate-sensor-sm.a6c063fc.svg";